import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Login } from 'src/app/models/Login';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private api: ApiService) { }

  public login(data: Login): Observable<any> {
    return this.api.post(`/oauth/token`, data, `user`)
  }


  public adminLogin(data: Login): Observable<any> {
    return this.api.post(`/api/login`, data, `user`)
  }


  public getAllUsers(selectedFranchise: any, selectedShop: any): Observable<any> {
    var data = this.api.get(`/api/v1/users?franchise=${selectedFranchise}&shop=${selectedShop}`, `user`)
    return data;
  }


  public getUsersPagination(nextUrl: any, selectedFranchise: any, selectedShop: any): Observable<any> {
    var data = this.api.get(`/api/v1/users?page=${nextUrl}&franchise=${selectedFranchise}&shop=${selectedShop}`, `user`)
    return data;
  }


  public createUser(data: any): Observable<any> {
    return this.api.post(`/api/v1/users`, data, `user`)
  }


  public editUser(id: any, data: any): Observable<any> {
    return this.api.put(`/api/v1/users/` + id, data, `user`)
  }


  public deleteUser(id): Observable<any> {
    var data = this.api.delete(`/api/v1/users/` + id, `user`)
    return data;
  }


  public updatePassword(id, password): Observable<any> {
    return this.api.post(`/api/v1/users/change-password/` + id, { password: password, password_confirmation: password }, `user`)
  }


  public getUser(id): Observable<any> {
    return this.api.get(`/api/v1/users/` + id, 'user')
  }


  public getCurrentUser(): Observable<any> {
    return this.api.get(`/api/v1/users/current`, 'user')
  }


  public getFranshiseAdmins(): Observable<any> {
    return this.api.get(`/api/v1/admin/franchise`, 'user')
  }


  public getOutletAdmins(): Observable<any> {
    return this.api.get(`/api/v1/admin/outlet`, 'user')
  }


  public getPolicies(): Observable<any> {
    return this.api.get(`/api/v1/users/policy-list`, 'user')
  }


  public getRoles(): Observable<any> {
    return this.api.get(`/api/v1/users/role-list`, 'user')
  }


  public searchUsers(keyword: any): Observable<any> {
    return this.api.get(`/api/v1/users/search?search_term=${keyword}`, 'user')
  }


  public getLoyalty(page: any): Observable<any> {
    return this.api.get(`/api/v1/loyalty?page=${page}`, 'user')
  }

  public updateLoyaltyInfo(brand: string, data: any): Observable<any> {
    return this.api.post(`/api/v1/hq/webshop-brand/${brand}/update-loyalty`, data, `user`)
  }

}
